export default __webpack_public_path__ + "static/media/sico_place_vendome.2f1b7ba0.jpg";